import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {canActivate, redirectLoggedInTo,redirectUnauthorizedTo } from '@angular/fire/auth-guard';

const redirectToHome= ()=>redirectLoggedInTo(['/home']);
const redirectUnauthorizedToLogin =()=> redirectUnauthorizedTo(['/'])
const routes: Routes = [  
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./public/login/login.module').then( m => m.LoginPageModule),
    ...canActivate(redirectToHome)
  },
  {
    path: 'recovery',
    loadChildren: () => import('./public/recovery/recovery.module').then( m => m.RecoveryPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./private/home.module').then( m => m.HomePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'terminos',
    loadChildren: () => import('./public/terminos/terminos.module').then( m => m.TerminosPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
